export const ADMIN_USERS_IMPORT_ENTITY_TYPE = 'IamUserAdmin';

export const ADMIN_USERS_IMPORT_MAX_ERRORS = 100;

export const ADMIN_USERS_IMPORT_CONFIG = {
  label: 'Admin Users',
  entityType: ADMIN_USERS_IMPORT_ENTITY_TYPE,
  importerPath: 'importers-users',
  permissions: ['iam.policy.update', 'iam.policy.import'],
  filePattern: '.xlsx',
  maxErrors: ADMIN_USERS_IMPORT_MAX_ERRORS
};
